// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BackToHomeArrow-backArrow-nXBEe {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  width: 38px;
  height: 38px;
  -ms-flex-negative: 0;
      flex-shrink: 0;
  margin-right: 6px;
  border-radius: 50%;
  border: 1px solid #e3e8ef;
  border: 1px solid var(--primary-border, #e3e8ef);
  background: #fff;
  color: #12395c;
  color: var(--secondary-oscuro, #12395c);
  text-decoration: none;
  cursor: pointer;
  -webkit-box-shadow: 0 1px 4px rgba(18, 57, 92, 0.12);
          box-shadow: 0 1px 4px rgba(18, 57, 92, 0.12);
  -webkit-transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease, -webkit-box-shadow 0.2s ease;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease, -webkit-box-shadow 0.2s ease;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease, -webkit-box-shadow 0.2s ease;
}

.BackToHomeArrow-backArrow-nXBEe:hover,
.BackToHomeArrow-backArrow-nXBEe:focus {
  background: color-mix(in srgb, #cfeaff 45%, #fff);
  background: color-mix(in srgb, var(--secondary-cielo, #cfeaff) 45%, #fff);
  border-color: #00b3c6;
  border-color: var(--primary-color, #00b3c6);
  color: #12395c;
  color: var(--secondary-oscuro, #12395c);
  text-decoration: none;
  -webkit-box-shadow: 0 2px 8px rgba(18, 57, 92, 0.18);
          box-shadow: 0 2px 8px rgba(18, 57, 92, 0.18);
}

.BackToHomeArrow-backArrow-nXBEe:focus-visible {
  outline: 2px solid #00b3c6;
  outline: 2px solid var(--primary-color, #00b3c6);
  outline-offset: 2px;
}

.BackToHomeArrow-backArrow-nXBEe svg {
  display: block;
}

@media screen and (max-width: 1199px) {
  .BackToHomeArrow-backArrow-nXBEe {
    width: 34px;
    height: 34px;
    margin-right: 2px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/BackToHome/BackToHomeArrow.css"],"names":[],"mappings":"AAAA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oBAAc;MAAd,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,yBAAgD;EAAhD,gDAAgD;EAChD,gBAAgB;EAChB,cAAuC;EAAvC,uCAAuC;EACvC,qBAAqB;EACrB,eAAe;EACf,oDAA4C;UAA5C,4CAA4C;EAC5C,+GAA+F;EAA/F,uGAA+F;EAA/F,+FAA+F;EAA/F,6HAA+F;AACjG;;AAEA;;EAEE,iDAAyE;EAAzE,yEAAyE;EACzE,qBAA2C;EAA3C,2CAA2C;EAC3C,cAAuC;EAAvC,uCAAuC;EACvC,qBAAqB;EACrB,oDAA4C;UAA5C,4CAA4C;AAC9C;;AAEA;EACE,0BAAgD;EAAhD,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;AACF","sourcesContent":[".backArrow {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 38px;\n  height: 38px;\n  flex-shrink: 0;\n  margin-right: 6px;\n  border-radius: 50%;\n  border: 1px solid var(--primary-border, #e3e8ef);\n  background: #fff;\n  color: var(--secondary-oscuro, #12395c);\n  text-decoration: none;\n  cursor: pointer;\n  box-shadow: 0 1px 4px rgba(18, 57, 92, 0.12);\n  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.backArrow:hover,\n.backArrow:focus {\n  background: color-mix(in srgb, var(--secondary-cielo, #cfeaff) 45%, #fff);\n  border-color: var(--primary-color, #00b3c6);\n  color: var(--secondary-oscuro, #12395c);\n  text-decoration: none;\n  box-shadow: 0 2px 8px rgba(18, 57, 92, 0.18);\n}\n\n.backArrow:focus-visible {\n  outline: 2px solid var(--primary-color, #00b3c6);\n  outline-offset: 2px;\n}\n\n.backArrow svg {\n  display: block;\n}\n\n@media screen and (max-width: 1199px) {\n  .backArrow {\n    width: 34px;\n    height: 34px;\n    margin-right: 2px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backArrow": `BackToHomeArrow-backArrow-nXBEe`
};
module.exports = ___CSS_LOADER_EXPORT___;
